import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import Quotation from "../../_shark_models/Quotation";

import templateContent from "./site-info-sheet-actions.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../waitBox/waitBoxComponent";

class SiteInfoSheetActionsComponent extends Component {
	constructor () {
		super("siteInfoSheetActionsComponent");
		this.addTemplate("", templateContent);
	}

	addQuotationDocumentBtn_clickHandler () {
		document.querySelector("#uploadedQuotation").click();
	}

	init () {
		this.addComponents([waitBoxComponent]);
		this.set({
			quotationAllowedExtensions: [".pdf", ".doc", ".docx", ".xls", ".xlsx"],
			__showCreateOptions: false,
			__showEditOptions: false,
		});
	}
	
	open (mode, quotationSuggestedNumber = "", sourceQuotation = null) {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

		const currQuotationData = Shark.getInstance("__smart__", {
			cca: "",
			date: moment().format(Shark.$store.dtIsoDate),
			handDelivered: currSiteInfoSheet.extraData.quotation.handDelivered,
			number: quotationSuggestedNumber,
			pdfURL: "",
			revision: sourceQuotation ? sourceQuotation.revision + 1 : 0,
			revisionReferenceGuid: sourceQuotation ? sourceQuotation.revisionReferenceGuid || sourceQuotation.guid : "",
			sendingDate: "0000-00-00 00:00:00",
			status: 0,
			__uploadedDocumentName: "",
		});
		
		console.log({sourceQuotation, currQuotationData});

		Shark.set({
			currQuotationData,
			__showCCA: mode === "CCA",
			__todayISO: moment().format(Shark.$store.dtIsoDate),
		});

		Shark.render();

		$("#siteInfoSheetActionsModal").modal("show");
	}

	show (mode, quotationSuggestedNumber = "", sourceQuotation = null) {
		this.open(mode, quotationSuggestedNumber, sourceQuotation);
	}

	siteInfoSheetActionsModalConfirmBtn_clickHandler () {
		let errorCount = 0;

		const currQuotationData = Shark.get("currQuotationData");
		if (currQuotationData.number.trim() === "") {
			const numberField = document.querySelector("#siteInfoSheetActionsModal #numberField");

			if (numberField) {
				numberField.classList.add("is-invalid");
			}
			errorCount++;
		}
		
		const newQuotation = Shark.get("newQuotation");
		const addQuotationDocumentBtn = document.querySelector("#siteInfoSheetActionsModal #addQuotationDocumentBtn");
		if (!newQuotation) {
			if (addQuotationDocumentBtn) {
				addQuotationDocumentBtn.classList.remove("btn-primary");
				addQuotationDocumentBtn.classList.add("btn-danger");
			}
			errorCount++;
		}
		else {
			if (addQuotationDocumentBtn) {
				addQuotationDocumentBtn.classList.add("btn-primary");
				addQuotationDocumentBtn.classList.remove("btn-danger");
			}
		}

		if (errorCount > 0) {
			return;
		}
		
		waitBoxComponent.open();

		const { currSiteInfoSheet } = Shark.get();

		if (currSiteInfoSheet) {
			$(`#siteInfoSheetActionsModal`).modal("hide");

			if (currSiteInfoSheet.extraData.quotation && currSiteInfoSheet.extraData.quotation.number !== "") {
				const previousData = Object.assign({}, currSiteInfoSheet.extraData.quotation);

				if (currSiteInfoSheet.extraData.quotationRevisions) {
					currSiteInfoSheet.extraData.quotationRevisions.push(previousData);
				}
				else {
					currSiteInfoSheet.extraData.quotationRevisions = [previousData];
				}
			}

			//Dave: qui c'è da revisionare
			currSiteInfoSheet.extraData.quotation = currQuotationData.export();
			currSiteInfoSheet.extraData.quotation.status = currSiteInfoSheet.extraData.quotation.handDelivered ? 4 : 1;
			currSiteInfoSheet.extraData.quotation.sendingDate = moment().utc().format(Shark.get("dateISOFormat"));

			// Shark.set({currSiteInfoSheet});
			// document.querySelector("#uploadedQuotation").click();

			newQuotation.code = currQuotationData.number;
			newQuotation.referenceDate = currQuotationData.date;

			quotationManager.save(newQuotation)
			.then(jsonResponse => {
				const currUser = Shark.get("currUser");

				currSiteInfoSheet.extraData.quotation.guid = jsonResponse.data.guid;
				currSiteInfoSheet.extraData.relatedGuids.quotationGuid = jsonResponse.data.guid;
				console.log(currSiteInfoSheet);
				siteInfoSheetManager.save(currSiteInfoSheet);

				visitManager.getByClientGuid(currSiteInfoSheet.clientGuid)
				.then(getVisitResponse => {
					const visit = getVisitResponse.data[0];

					if (visit) {
						if (visit.extraData.quotations) {
							visit.extraData.quotations.push({guid: newQuotation.guid, status: newQuotation.status});
						}
						else {
							visit.extraData.quotations = [{guid: newQuotation.guid, status: newQuotation.status}];
						}

						visitManager.save(visit);
					}
				});

				//Dave.Warn: sono abbastanza convinto che questa roba sia orribile
				const newRevisionQuotation = Shark.get("newRevisionQuotation");
				if (newRevisionQuotation && newRevisionQuotation.guid !== "") {
					quotationManager.archive(newRevisionQuotation.guid);
					quotationManager.getList();
					Shark.set({newRevisionQuotation: null});
				}

				const quotationAgent = Utils.safp(Shark.get("userList"), "guid", currSiteInfoSheet.userGuid);
				const nextStepContent = currSiteInfoSheet.extraData.quotation.handDelivered ? "<strong>Ricordati che hai chiesto di consegnare a mano questo preventivo.</strong>" : "Riceverai un'eMail quando il preventivo otterrà un riscontro dal cliente.";
				
				const body = `BuonGiorno ${quotationAgent.firstName},
				
					questa eMail per comunicare che è stato caricato ${(currSiteInfoSheet.extraData.quotationRevisions && currSiteInfoSheet.extraData.quotationRevisions.length > 0) ? "<strong>un nuovo preventivo</strong>" : "il preventivo"} con numero <strong>${newQuotation.code}</strong>, relativo alla scheda informativa del <strong>${currSiteInfoSheet.__referenceDateLabel}</strong> per <strong>${currSiteInfoSheet.registry.clientName}</strong>.

					Puoi visualizzare il Preventivo <a href="${Shark.get("__cdnURL")}/${newQuotation.pdfURL}">cliccando qui</a>.
					
					Puoi visualizzare le Schede Informative <a href="${Shark.get("agentAppURL")}/#quotationListView">cliccando qui</a>.

					${nextStepContent}

					Buona Giornata,
					IPM HUB
				`;

				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: currUser.email,
					senderName: currUser.__fullName,
					subject: "IPM HUB | Preventivo inserito",
					receiverEMail: quotationAgent.email,
					receiverName: quotationAgent.__fullName,
				});
				userManager.sendMessage(currMessage);

				//const newQuotation = Shark.get(", "newQuotation"]);
				//Questa roba sta diventando un casino, troppi incroci e chiamate nastosce
				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: newQuotation.revision === 0 ? "Caricato il Preventivo '" + newQuotation.code + "' per la Scheda Informativa '" + currSiteInfoSheet.getAutoFolderName() + "'." : "Aggiunta revisione per il Preventivo '" + newQuotation.code + "'.",
					clientGuid: newQuotation.clientGuid,
					referenceGuid: newQuotation.guid,
					referenceType: "quotation",
					status: 3,
					type: "system"
				});
				console.log({newFollowUp});
		
				followUpManager.save(newFollowUp)
				.then(followUpSaveResponse => {
					console.log({followUpSaveResponse});
				});

				Shark.set({newQuotation: null});
				
				waitBoxComponent.close();

				if (Shark.activePage.refreshList) {
					Shark.activePage.refreshList();
				}
			});
		}
	}

	uploadedQuotation_changeHandler (event) {
		// Dave.ToDo: Anche questo dovrebbe essere un "document" e salvato nel preventivo come riferimento al guid.
		const files = event.target.files;

		if (files.length === 0) {
			return;
		}

		const { currSiteInfoSheet } = Shark.get();

		if (currSiteInfoSheet) {
			waitBoxComponent.open();

			const fileToUpload = files[0];
			const fileName = fileToUpload.name;
			event.target.dataset.saveName = currSiteInfoSheet.guid.substr(0, 13) + "_quot_" + fileName.slice(0, fileName.lastIndexOf(".")).replace(/ /g, "-");

			const fileExtension = fileName.slice(fileName.lastIndexOf("."));

			if (this.$store.quotationAllowedExtensions.indexOf(fileExtension) === -1) {
				alert("Attenzione, il file selezionato è in un formato non sono supportati, non posso procedere.\n\nSe è necessario inviare questo file contattate il supporto tecnico.");
				waitBoxComponent.close();
				return;
			}

			siteInfoSheetManager.uploadQuotation(event.target)
			.then(uploadQuotationResponse => {
				const uploadedQuotation = uploadQuotationResponse.data[0];


				if (uploadedQuotation?.errors?.length > 0) {
					alert(`Attenzione, si è verificato il seguente errore:\n\n"${uploadedQuotation.errors[0].error}"\n\nSe è necessario inviare questo file contattate il supporto tecnico.`);
					waitBoxComponent.close();
					return;
				}

				// const siteInfoSheetActionsModal_quotationPreviewBox = document.querySelector("#siteInfoSheetActionsModal_quotationPreviewBox");
				// if (siteInfoSheetActionsModal_quotationPreviewBox) {
				const { currUser, currQuotationData } = Shark.get();

				let quotationPreview = `Documento inviato:<br><br>
					<strong>${uploadedQuotation.name}.${uploadedQuotation.type}</strong>
				`;

				// siteInfoSheetActionsModal_quotationPreviewBox.innerHTML = quotationPreview;
				currQuotationData.set({
					__uploadedDocumentName: quotationPreview,
				});

				currSiteInfoSheet.extraData.quotation.pdfURL = uploadedQuotation.filePath;
				currSiteInfoSheet.extraData.quotation.status = currSiteInfoSheet.extraData.quotation.handDelivered ? 4 : 1;
				currSiteInfoSheet.extraData.quotation.sendingDate = moment().utc().format(Shark.get("dateISOFormat"));

				let receiverGuid = currSiteInfoSheet.registry[`${currSiteInfoSheet.registry.receiver}Guid`];

				//Dave: Forse il quotation dovrebbe esser gestito dal quotationManager?
				// Ma perché passo tutti i valori di default? Ormai li dovrebbe prednere da sè...
				// const newQuotation = Shark.getInstance("Quotation", {
				const newQuotation = new Quotation({
					clientGuid: receiverGuid,//currSiteInfoSheet.clientGuid,
					code: currQuotationData.number,
					extraData: {
						confirmData: {
							conditions: "",
							pictures: [],
							timeSpanAndApplicatorTeam: {
								applicatorTeamId: "",
								timeSpanEnd: "0000-00-00 00:00:00",
								timeSpanStart: "0000-00-00 00:00:00",
							},
							userGuid: ""
						},
						handDelivered: currSiteInfoSheet.extraData.quotation.handDelivered,
						relatedGuids: {
							clientGuid: receiverGuid,
							siteInfoSheetGuid: currSiteInfoSheet.guid,
							visitGuid: currSiteInfoSheet.extraData.relatedGuids.visitGuid,
						},
						refuseReason: "",
						siteLocation: {
							address: "",
							city: "",
							name: "",
							province: "",
							region: "",
							zip: "",
							personInCharge: {
								name: "",
								eMail: "",
								phone: ""
							},
						}
					},
					pdfURL: currSiteInfoSheet.extraData.quotation.pdfURL,
					referenceDate: currQuotationData.date,
					revision: currQuotationData.revision,
					revisionReferenceGuid: currQuotationData.revisionReferenceGuid,
					sendingDate: moment(),
					siteInfoSheetData: {
						agentGuid: currSiteInfoSheet.userGuid,
						agentName: currSiteInfoSheet.__agentName,
						clientCommoditySector: currSiteInfoSheet.registry.clientCommoditySector,
						clientName: currSiteInfoSheet.registry.clientName,
						clientProvince: currSiteInfoSheet.registry.clientProvince,
						referenceDate: currSiteInfoSheet.referenceDate.format(Shark.get("dateISOFormat")),
						systems: JSON.parse(currSiteInfoSheet.export().systems),
					},
					siteInfoSheetGuid: currSiteInfoSheet.guid,
					status: currSiteInfoSheet.extraData.quotation.status,
					userGuid: currUser.guid,
				});

				Shark.set({newQuotation});
				console.log({currSiteInfoSheet, newQuotation});
				// }

				const addQuotationDocumentBtn = document.querySelector("#siteInfoSheetActionsModal #addQuotationDocumentBtn");
				if (addQuotationDocumentBtn) {
					addQuotationDocumentBtn.classList.add("btn-primary");
					addQuotationDocumentBtn.classList.remove("btn-danger");
				}
			
				waitBoxComponent.hide();
			});
		}
	}










	

	siteInfoSheetActionsModalCancelBtn_clickHandler () {
		Shark.set({newQuotation: null});

		$(`#siteInfoSheetActionsModal`).modal("hide");
	}

}

const siteInfoSheetActionsComponent = new SiteInfoSheetActionsComponent();

Shark.registerComponent(siteInfoSheetActionsComponent);

export { siteInfoSheetActionsComponent };
